import { useStoreActions, useStoreState } from 'store'

import React, { ChangeEvent } from 'react'

import { BankratePropertyType } from '@bankrate/mortgage-types'

const options = [
  { label: 'Single-family home', value: 'SingleFamily' },
  { label: 'Multi-family home', value: 'MultiFamily2Units' },
  { label: 'Condominium', value: 'Condo4OrFewerStories' },
  { label: 'Townhome', value: 'Townhouse' },
  { label: 'Duplex', value: 'MultiFamily2Units' },
  { label: 'Triplex', value: 'MultiFamily3Units' },
  { label: 'Quad', value: 'MultiFamily4Units' },
]

export default function PropertyType() {
  const {
    mortgageType,
    purchase: { propertyType: purchasePropertyType },
    refinance: { propertyType: refinancePropertyType },
  } = useStoreState(state => state.dimensions.dimensions)
  const { onInputTracking } = useStoreActions(actions => actions.tracking)
  const { updateDimensions } = useStoreActions(actions => actions.dimensions)

  const handleChange = (event: ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value as BankratePropertyType
    const updateKey = mortgageType === 'Purchase' ? 'purchase' : 'refinance'

    updateDimensions({ [updateKey]: { propertyType: value } })
    onInputTracking({
      value,
      type: 'UNITTYPE',
      name: 'propertytype',
      label: 'property type',
    })
  }

  return (
    <>
      <div className="FormControl" style={{ maxWidth: 'initial' }}>
        <label className="FormLabel mb-1" htmlFor="propertyType">
          Property type
        </label>
        <select
          id="propertyType"
          data-testid="propertyType"
          className="FormSelect font-circular-book type-body-one text-black mb-4"
          value={mortgageType === 'Purchase' ? purchasePropertyType : refinancePropertyType}
          onChange={handleChange}
        >
          {options.map((option: { value: string; label: string }) => (
            <option key={`property-type-${option.label}`} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <span className="FormSelect-arrow Icon Icon--xs">
          <svg
            className="Icon-glyph"
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="-1 -2 8 8"
            aria-hidden="true"
          >
            <path d="M.707 0L0 .697 3.354 4 6.707.697 6 0 3.359 2.602z" fillRule="evenodd" />
          </svg>
        </span>
      </div>
    </>
  )
}
